/* global I18n */
import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { BundlesPriceModalStyles as styles, BundlePriceButton } from '../../../utils/BundlesPriceModalStyles'

const BundlesPriceModal = ({ show, hideModal, hideModalButton, recommendedPrice, i18nOptions }) => (
  <Modal show={show} onHide={hideModal} style={styles.modal} >
    <Modal.Header closeButton style={styles.header}>
      <Modal.Title style={styles.title}>Pricing Error</Modal.Title>
    </Modal.Header>
    <Modal.Body style={styles.body}>
      {I18n.t('pricing_error', { ...i18nOptions, recommendedPrice: recommendedPrice })}
    </Modal.Body>
    <Modal.Footer style={styles.footer}>
      <BundlePriceButton onClick={hideModalButton}>OK</BundlePriceButton>
    </Modal.Footer>
  </Modal>
)

BundlesPriceModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default BundlesPriceModal
